"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BrandingType = void 0;
/**
 * Main branding enum for switching between the style definitions
 */
var BrandingType;
(function (BrandingType) {
    BrandingType["BAM"] = "BAM";
    BrandingType["RELIC"] = "RELIC";
    BrandingType["TICKETHEAD"] = "TICKETHEAD";
})(BrandingType = exports.BrandingType || (exports.BrandingType = {}));
//# sourceMappingURL=branding.js.map